import React from 'react';
import './Loader.css'; // CSS stilini burada yükle

const LineWobble = () => {
  return <div className="line-wobble"></div>;
};

export default LineWobble;